import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MotorsUiRouteGuard implements CanActivate {
    constructor(private _router: Router) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
            const queryParams = next.queryParams;
            if (!(next.children.length > 0)) {
                // a workaround solution until angular supports it officially
                // more info at https://github.com/angular/angular/issues/27148#issuecomment-831414318
                this._router.getCurrentNavigation().extras.skipLocationChange =
                    true;

                return this._router.createUrlTree(['404'], { queryParams });
            }
            return true;
    }
}
